import { useMemo, useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { TableBody } from "../TablesBasePage/TableBody";
import { TableHeader } from "../TablesBasePage/TableHeader";
import "../TablesBasePage/TablesBasePage.scss";

const productHeaderDefinitions = {
  header: [
    {
      columns: [
        {
          title: "order",
          path: "order",
          disabled: false,
          filtered: false,
          type: "number",
          valuetype: "number",
          translationKey: "tables.products.order",
          translationNamespace: "tables",
        },
        {
          title: "name",
          path: "name",
          disabled: false,
          filtered: false,
          type: "string",
          translationKey: "tables.products.name",
          translationNamespace: "tables",
        },
        {
          title: "eurocode",
          path: "eurocode",
          type: "checkbox",
          valuetype: "boolean",
          filtered: false,
          disabled: false,
          translationKey: "tables.products.eurocode",
          translationNamespace: "tables",
        },
        {
          title: "germany",
          path: "germany",
          type: "checkbox",
          valuetype: "boolean",
          filtered: false,
          disabled: false,
          translationKey: "tables.products.germany",
          translationNamespace: "tables",
        },
        {
          title: "aashto",
          path: "aashto",
          type: "checkbox",
          valuetype: "boolean",
          filtered: false,
          disabled: false,
          translationKey: "tables.products.aashto",
          translationNamespace: "tables",
        },
      ],
    },
  ],
};

export default function Products({ functions: productFunctions }) {
  const [currentPage, setCurrentPage] = useState(1);
  let pageSize = 20;
  const { isLoading, data: elements } = productFunctions.GetAll();

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    let res = elements?.slice(firstPageIndex, lastPageIndex);
    if (res?.length === 0 && currentPage !== 1) setCurrentPage(currentPage - 1);
    return res;
  }, [pageSize, currentPage, elements]);

  if (isLoading) return <p>loading...</p>;
  return (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          {!isLoading && (
            <>
              <TableHeader
                headerDefs={productHeaderDefinitions}
                translationPrefix={"tables.products"}
              />
              <TableBody
                columns={productHeaderDefinitions.header[0].columns}
                currentTableData={currentTableData}
                functions={productFunctions}
              />
            </>
          )}
        </table>
      </div>

      {elements && (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={elements?.length}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </>
  );
}
